import React from "react";
import logger from "logger";
import axios from "axios";
import Constants from "Utils/Constants";
import Header from "Common/Header";
import store from "store";
import { getWrappedJSON, getPublicData } from "Utils/Common";
import { withRouter } from "react-router-dom";
import qs from "qs";
import TaskInput from "TaskDialogCommon/TaskInput";
import toastMaker from "Common/toastmaker";
import { DialogButton } from "Common/DialogButton";

export const loadData = (user, history) => {
  return refresh().then(() => {
    history.push(Constants.accounts);
  });
};

const refresh = () => {
  var dataparams = getWrappedJSON({});
  store.dispatch({ type: "ISLOADING", payload: true });
  return axios
    .post(Constants.getaccountsApiPath, dataparams)
    .then((response) => {
      logger.log("add Tags response", response.data);
      store.dispatch({ type: "SETACCOUNTS", payload: response.data.data });
      store.dispatch({ type: "ISLOADING", payload: false });
    });
};

class WallRemoverComponent extends React.Component {
  constructor(props) {
    super();
    logger.log("Constructor called!");
    const passcode = qs.parse(props.location.search, {
      ignoreQueryPrefix: true,
    }).passcode;
    this.state = {
      wallremoverconfig: null,
      passcode,
      x: "",
      y: "",
    };
    //clear query parameter so that page doesnt enter in infinite loop
    props.history.push(Constants.wallremover);
  }

  hitcoords = () => {
    const { passcode, x, y } = this.state;
    if (!passcode || passcode.length == 0) {
      toastMaker.makeToast("Enter passcode for wallremover", {
        variant: "error",
      });
      return;
    }
    if (x <= 0 || x > 800 || y <= 0 || y > 800) {
      toastMaker.makeToast("X and Y coords should be between 1-800", {
        variant: "error",
      });
      return;
    }
    const dataparams = {
      datakey: "wallremoverhitcoords",
      passcode,
      x,
      y,
    };
    return getPublicData(dataparams, ({ data: { ok, data, message } }) => {
      if (ok && data.message) {
        toastMaker.makeToast(data.message, {
          variant: "success",
        });
      }
    });
  };

  componentWillUnmount = () => {
    logger.log("I will unmount..");
  };

  loadwallremover = () => {
    const { passcode } = this.state;
    logger.log("In loadwallremover");
    if (!passcode || passcode.length == 0) {
      toastMaker.makeToast("Enter passcode for wallremover", {
        variant: "error",
      });
      return;
    }
    logger.log("In loadwallremover 2");
    const dataparams = {
      datakey: "getwallremover",
      passcode,
    };
    return getPublicData(dataparams, ({ data: { ok, data } }) => {
      logger.log(ok, data);
      if (ok && data.wallremoverconfig) {
        logger.log("here", data.wallremoverconfig);
        this.setState((s, p) => {
          logger.log("previous state");
          const stateChange = {
            wallremoverconfig: {
              ...(s.wallremoverconfig || {}),
              ...data.wallremoverconfig,
            },
          };
          logger.log("stateChange", stateChange);
          return stateChange;
        });
      }
    });
  };

  render = () => {
    logger.log("this.state", this.state);
    logger.log("location", this.props.location);
    const { wallremoverconfig, passcode, x, y } = this.state;

    const { protocol, hostname, port } = window.location;

    logger.log(
      `${protocol}//${hostname}${port ? ":" + port : ""}/#/ui/wallremover`
    );

    return (
      <div>
        <Header />
        <br />
        <br />
        <div className="komform" style={{ padding: "20px" }}>
          <div style={{ maxWidth: "500px", margin: "0 auto" }}>
            <TaskInput
              placeholder="Enter wallremover passcode"
              value={passcode}
              onChange={(e) => {
                this.setState({ passcode: e.target.value });
              }}
            />
            <DialogButton
              label="Load Wall Remover"
              style={{ fontSize: "18px" }}
              onClick={(e) => {
                logger.log(e);
                this.loadwallremover();
              }}
            />
          </div>
          {wallremoverconfig && (
            <div style={{ maxWidth: "500px", margin: "0 auto" }}>
              <br />
              <div>Server {wallremoverconfig.server}</div>
              <br />
              <div>Enter Coords to hit(x,y):</div>
              <div
                style={{
                  display: "flex",
                  marginTop: "20px",
                  justifyContent: "center",
                }}
              >
                <TaskInput
                  placeholder="X Coord"
                  style={{ width: "100px" }}
                  value={x}
                  onChange={(e) => {
                    this.setState({ x: e.target.value });
                  }}
                />
                <TaskInput
                  placeholder="Y Coord"
                  style={{ width: "100px" }}
                  value={y}
                  onChange={(e) => {
                    this.setState({ y: e.target.value });
                  }}
                />
              </div>
              <DialogButton
                label="Hit Cooords"
                style={{ fontSize: "20px" }}
                onClick={this.hitcoords}
              />
            </div>
          )}
        </div>
        <br />
      </div>
    );
  };
}

export const WallRemover = withRouter(WallRemoverComponent);
